import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Sidebar from './sidebar';
import Overlay from '../components/overlay';
import Header from './header';
import { get_endofday_report } from '../actions/index';
import DayPicker from 'react-day-picker';
import _ from 'lodash';


class EndofDay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDay: new Date(),
      report_day: '',
      report_created: '',
    }

    this.handleDownload = this.handleDownload.bind(this);
    this.handleReport = this.handleReport.bind(this);
  }

  handleDayClick = day => {
    this.setState({
      selectedDay: day
    });
  }

  handleReport() {
    // fire action to get end of day values from the API
    // Date should be in format 9/23/2011 (M/D/YYYY)

    this.setState({
      report_day: this.state.selectedDay,
      report_created: Date()
    });

    var report_date = new Date(this.state.selectedDay);
    report_date = (report_date.getMonth()+1)+"/" + report_date.getDate() + "/" + report_date.getFullYear();

    this.props.get_endofday_report(report_date);
  }

  handleDownload() {

    /*
    var pdfConverter = require('jspdf');

    var doc = new pdfConverter('p','pt','c6');

    doc.setFontSize(22);
    doc.text(20, 50, 'Park Entry Ticket');
    doc.setFontSize(16);
    doc.text(20, 80, 'Address1: ');
    doc.text(20, 100, 'Address2: ');
    doc.text(20, 120, 'Entry Date & time: ');
    doc.text(20, 140, 'Expiry date & time: ');
    doc.save("test.pdf");
    */
  }

  renderReport() {
    if (this.state.report_day === '') {
      return (
        <div></div>
      );
    }
    if (_.isEmpty(this.props.reports.items) && (this.props.reports.items !== undefined)) {
      return <div>There is no data for this time period.</div>
    } else if (_.isEmpty(this.props.reports.items) === false ) {
      return(
        <div>
          <table className="table mb-0 table-bordered">
            <thead className="thead-inverse">
              <tr>
                <th colSpan="2">Created on: {this.state.report_created} <br /> EOD Report for {this.state.report_day.toLocaleDateString()}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th><b>Sales</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <th scope="row">Total</th>
                <td>${this.props.reports.items.sales_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Discounts</th>
                <td>(${this.props.reports.items.discounts_total})</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Gross</th>
                <td>${this.props.reports.items.gross_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">HST</th>
                <td>${this.props.reports.items.hst_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Net</th>
                <td>${this.props.reports.items.net_total}</td>
              </tr>

              <tr>
                <th><b>Receipts</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <th scope="row">Cash</th>
                <td>${this.props.reports.items.cash_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Debit</th>
                <td>${this.props.reports.items.debit_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Visa</th>
                <td>${this.props.reports.items.visa_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Mastercard</th>
                <td>${this.props.reports.items.mastercard_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Amex</th>
                <td>${this.props.reports.items.amex_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Total</th>
                <td>${this.props.reports.items.total_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">&nbsp;</th>
                <td>&nbsp;</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">CC Tip</th>
                <td>${this.props.reports.items.tip_total}</td>
              </tr>
              <tr className="bg-white">
                <th scope="row">Cash due</th>
                <td>${this.props.reports.items.cashdue_total}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
  }

  render() {
    // If the server has yet to send back report items, then show the loading page
    if (this.props.reports.loading) {
      return(
        <div>
          <Overlay />
          <Sidebar />
          <Header />
          <div className="site-content">
            <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
              <div className="col-md-4 mb-2 mb-md-0">
                <h5>Choose a day and click Load Report.</h5>
                <DayPicker
                  onDayClick={this.handleDayClick}
                  selectedDays={this.state.selectedDay}
                />
                <br />
                <input type="button" className="btn btn-primary btn-block b-a" onClick={event => this.handleReport()} value="Load Report" />
              </div>
            </nav>
            <div className="content-area py-1">
              <div className="container-fluid">
                Loading ...
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Overlay />
        <Sidebar />
        <Header />
        <div className="site-content">
          <nav className="navbar navbar-light bg-white navbar-bottom-line b-a mb-1 p-1">
            <div className="col-md-4 mb-2 mb-md-0">
              <h5>Choose a day and click Load Report.</h5>
              <DayPicker
                onDayClick={this.handleDayClick}
                selectedDays={this.state.selectedDay}
              />
              <br />
              <input type="button" className="btn btn-primary btn-block b-a" onClick={event => this.handleReport()} value="Load Report" />
            </div>
          </nav>
          <div className="content-area py-1">
            <div className="container-fluid">
              {this.renderReport()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ reports }) {
  return { reports };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { get_endofday_report }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EndofDay);



// WEBPACK FOOTER //
// ./src/containers/endofday.js